import { render } from "./Motif.vue?vue&type=template&id=54df9788"
import script from "./Motif.vue?vue&type=script&lang=js"
export * from "./Motif.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__